import { AdminConsoleService } from "~/services/admin-console/admin-console.service";
import { ApplicationService } from "~/services/application/application.service";
import { ConversationService } from "~/services/conversation/conversation.service";
import { JWTService } from "~/services/jwt/jwt.service";
import { KnowledgeService } from "~/services/knowledge/knowledge.service";
import { KnowledgeDocumentService } from "~/services/knowledge-document/knowledge-document.service";
import { PresetAssociationService } from "~/services/preset-asso/preset-asso.service";
import { PresetService } from "~/services/preset/preset.service";
import { ReportTokenUsageService } from "~/services/report-token-usage/report-token-usage.service";
import { ScopeMasterService } from "~/services/scope-master/scope-master.service";
import { UserAssociationService } from "~/services/user-asso/user-asso.service";
import { UserService } from "~/services/user/user.service";
import { WorkflowService } from "~/services/workflow/workflow.service";
import { QuotaService } from "~/services/quota/quota.service";
import { PromptLibraryService } from "~/services/prompt-library/prompt-library.service";

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      services: {
        presetController: (configService = {}) => new PresetService(useApi, configService),
        presetAssoController: (configService = {}) => new PresetAssociationService(useApi, configService),
        conversationController: (configService = {}) => new ConversationService(useApi, configService),
        userAssoController: (configService = {}) => new UserAssociationService(useApi, configService),
        jwtController: (configService = {}) => new JWTService(useApiLogin, configService),
        applicationController: (configService = {}) => new ApplicationService(useApi, configService),
        scopeMasterController: (configService = {}) => new ScopeMasterService(useApi, configService),
        userController: (configService = {}) => new UserService(useApi, configService),
        adminConsoleController: (configService = {}) => new AdminConsoleService(useApi, configService),
        reportTokenUsageController: (configService = {}) => new ReportTokenUsageService(useApi, configService),
        workflowController: (configService = {}) => new WorkflowService(useApi, configService),
        knowledgeController: (configService = {}) => new KnowledgeService(useApi, configService),
        knowledgeDocumentController: (configService = {}) => new KnowledgeDocumentService(useApi, configService),
        quotaController: (configService = {}) => new QuotaService(useApi, configService),
        promptLibraryController: (configService = {}) => new PromptLibraryService(useApi, configService),
      }
    }
  }
});
